import React, { useState, useRef, useEffect } from 'react';

const AppBlock = () => {
  const [appear, setAppear] = useState(false);

  const historyRef = useRef();

  const handleScroll = () => {
    var top = window.pageYOffset;

    var introOffset;
    if (window.innerWidth < 450)
      introOffset = historyRef.current.offsetTop - window.innerHeight + 320;
    else introOffset = historyRef.current.offsetTop - window.innerHeight + 350;

    if (top >= introOffset) setAppear(true);
    else setAppear(false);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      ref={historyRef}
      // className={appear ? 'row main-history' : 'row main-history hide'}
      className='row native-app'
    >
      <div className='col-md-8 native-app-text'>
        <div className='overflow-hide'>
          <h2 className={appear ? 'h2-appear' : 'hide-btn'}>
            Our Native app for IOS/Android is also live now
          </h2>
        </div>
        <a
          rel='noopener noreferrer'
          target='_blank'
          href='https://expo.io/@aqibasif/projects/Beverix?release-channel=staging'
        >
          <button className={appear ? 'download-btn' : 'download-btn hide'}>
            <i className='fab fa-apple'></i>Download for iPhone
          </button>
        </a>
        <a
          rel='noopener noreferrer'
          target='_blank'
          href='https://expo.io/@aqibasif/projects/Beverix?release-channel=staging'
        >
          <button className={appear ? 'download-btn' : 'download-btn hide'}>
            <i className='fab fa-google-play'></i>Download for Android
          </button>
        </a>
      </div>

      <div className='col-md-4'>
        <img
          className={appear ? 'app-img' : 'app-img hide'}
          src='/img/app.png'
          alt='App'
        />
      </div>
    </div>
  );
};

export default AppBlock;
